/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'rating-smiley-1': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: `<defs><clipPath id="svgicon_rating-smiley-1_a"><path pid="0" d="M0 0h44v44H0z"/></clipPath></defs><g clip-path="url(#svgicon_rating-smiley-1_a)"><g transform="translate(-.75 -.332)" _fill="none" _stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"><circle pid="1" cx="21.25" cy="21.25" r="21.25" transform="translate(1.5 1.081)"/><path pid="2" d="M33.18 33.955a10.431 10.431 0 00-20.859 0"/><ellipse pid="3" cx="3.259" cy="3.196" rx="3.259" ry="3.196" transform="translate(15.179 15.253)"/><ellipse pid="4" cx="3.259" cy="3.196" rx="3.259" ry="3.196" transform="translate(24.087 15.253)"/><path pid="5" d="M21.59 17.81h2.607M30.5 17.81h13M1.816 17.81H15.5"/></g></g>`
  }
})
/* tslint:enable */
